import { Sans } from "../util/sdk";

export async function reportErrorToNR(error: string | Error, meta: Record<string, unknown> = {}) {
  const userId = await Sans.sdk.getUserId();
  const newrelic = (globalThis as { newrelic?: { noticeError: (error: unknown, meta?: object) => void } }).newrelic;
  if (newrelic) {
    console.log("Sending error:", error, meta, userId);
    newrelic.noticeError(error, { ...meta, userId });
  }
}
